import React from 'react';
import { StethoscopeIcon, TrophyIcon, StarIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustBadges } from './TrustBadges';
import { CHECKOUT_URLS } from '../data/checkout';
const basicIncludes = ['6 Tomos + 6 Bonos', '300+ recetas adaptadas', 'Menús semanales y listas de compras', 'Planificación completa'];
const proIncludes = ['6 Tomos + 6 Bonos', 'Kit de seguimiento médico y nutricional avanzado', 'Tabla de índice glucémico argentina', 'Plan estacional + dashboard mensual'];
export function PricingSection() {
  return <section id="precios" className="w-full scroll-mt-4 bg-beige py-16 sm:py-20" aria-labelledby="precios-title" data-id="element-222" data-mp="1x86um3xl5ax7">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-223" data-mp="227b28q4v30lf">
        <h2 id="precios-title" className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl lg:text-5xl" data-id="element-224" data-mp="2uyv3yyo0b58">
          <span aria-hidden="true" data-id="element-225" data-mp="1mgoezc1ojbkv">🇦🇷</span> Elegí tu MegaPack
        </h2>

        <div className="mt-12 grid items-start gap-6 lg:grid-cols-2" data-id="element-226" data-mp="1mirfwr4dep4d">
          <article className="flex h-full flex-col rounded-3xl border border-beige-deep bg-white p-7 sm:p-9" data-id="element-227" data-mp="1hp6f6rbe7h1h">
            <div className="flex items-center gap-3" data-id="element-228" data-mp="1crep82ub64zx">
              <StethoscopeIcon className="h-6 w-6 text-sage-deep" aria-hidden="true" data-id="element-229" data-mp="17sacj286dp4u" />
              <h3 className="font-display text-xl font-bold text-petrol" data-id="element-230" data-mp="25fagut50t6pu">
                MegaPack Cocina Para Diabéticos
              </h3>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-231" data-mp="20h8xe73on5du">
              {basicIncludes.map(item => <li key={item} className="flex gap-3 text-base text-body" data-id="element-232" data-mp="1vfrzmkghvz1h">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-233" data-mp="1repwvtndd4ur" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 border-t border-beige-deep pt-6 text-sm leading-relaxed text-body-muted" data-id="element-234" data-mp="g02xg68biksk">
              Ideal para: personas con diabetes y familiares que cocinan para ellas.
            </p>
            <div className="mt-auto pt-8" data-id="element-235" data-mp="mhe636xwkdvy">
              <p className="text-sm font-medium text-body-muted" data-id="element-236" data-mp="mg3339ca7a5w">
                <span className="line-through" data-id="element-237" data-mp="7ik4zgdprkls">$51.000</span> · Precio de lanzamiento
              </p>
              <p className="mt-1 font-display text-4xl font-extrabold text-petrol sm:text-5xl" data-id="element-238" data-mp="chnbz6d980we">
                $19.990 <span className="text-lg font-bold text-body-muted" data-id="element-239" data-mp="3uvmqhrq9tyd1">ARS</span>
              </p>
              <CtaButton href={CHECKOUT_URLS.megapack} className="mt-6 w-full" size="md" data-id="element-240" data-mp="3j1uzfnfktxq">
                Quiero mi MegaPack
              </CtaButton>
              <p className="mt-3 text-center text-xs font-medium text-body-muted" data-id="element-241" data-mp="3kwni8a9f44qk">
                Acceso en 5 minutos · Pago único
              </p>
            </div>
          </article>

          <article className="relative flex h-full flex-col rounded-3xl border-2 border-cta bg-petrol p-7 text-white shadow-xl sm:p-9" data-id="element-242" data-mp="3bzwoi4ic91z5">
            <span className="absolute -top-3.5 left-7 inline-flex items-center gap-1.5 rounded-full bg-cta px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-243" data-mp="2xal7pbbe8uxc">
              <StarIcon className="h-3.5 w-3.5 fill-white" aria-hidden="true" data-id="element-244" data-mp="36caz4h59ztv4" />
              Más elegido
            </span>
            <div className="flex items-center gap-3" data-id="element-245" data-mp="31bn83vh1rd0w">
              <TrophyIcon className="h-6 w-6 text-cta" aria-hidden="true" data-id="element-246" data-mp="3g9z8ac3mp3wt" />
              <h3 className="font-display text-xl font-bold" data-id="element-247" data-mp="3g84iajdi2llv">MegaPack + Kit Control Total</h3>
            </div>
            <ul className="mt-6 space-y-3" data-id="element-248" data-mp="3b91qi0mj6bvu">
              {proIncludes.map(item => <li key={item} className="flex gap-3 text-base text-white/85" data-id="element-249" data-mp="3p4djo3l1fuan">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-250" data-mp="3l17ihacs8tb1" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 border-t border-white/15 pt-6 text-sm leading-relaxed text-white/75" data-id="element-251" data-mp="3u25d521bzogy">
              Ideal para: personas que quieren llevar un registro profesional para compartir con su
              médico o nutricionista y ajustar el plan con datos reales.
            </p>
            <div className="mt-auto pt-8" data-id="element-252" data-mp="qpw9d57ycbzc">
              <p className="text-sm font-medium text-white/70" data-id="element-253" data-mp="qr671taw7i5g">
                <span className="line-through" data-id="element-254" data-mp="vpr0n9vn33kx">$69.000</span> · Precio de lanzamiento
              </p>
              <p className="mt-1 font-display text-4xl font-extrabold text-cta sm:text-5xl" data-id="element-255" data-mp="3v5nwrzam62cq">
                $27.990 <span className="text-lg font-bold text-white/70" data-id="element-256" data-mp="31v17xeoqxkg">ARS</span>
              </p>
              <CtaButton href={CHECKOUT_URLS.kitControlTotal} className="mt-6 w-full" size="md" data-id="element-257" data-mp="7zn2vj54ty1u">
                Quiero el Kit Control Total
              </CtaButton>
              <p className="mt-3 text-center text-xs font-medium text-white/70" data-id="element-258" data-mp="1jf21ssgwizzl">
                Acceso en 5 minutos · Pago único
              </p>
            </div>
          </article>
        </div>

        <TrustBadges className="mt-10 justify-center" guaranteeLabel="Garantía 7 días sin preguntas" data-id="element-259" data-mp="38w7b682p1gvf" />
      </div>
    </section>;
}